export default __webpack_public_path__ + "static/media/oceania_achievement.ae5ee51a.png";